export default class RoleService {
  constructor (http, store, router) {
    this.$http = http
    this.$store = store
    this.$router = router
  }

  getRoles () {
    return new Promise((resolve, reject) => {
      this.$http.get('roles')
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  getSystemRoles () {
    return new Promise((resolve, reject) => {
      this.$http.get('roles/system')
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  getPermissions () {
    return new Promise((resolve, reject) => {
      this.$http.get('permissions')
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  getRolePermissions (id) {
    return new Promise((resolve, reject) => {
      this.$http.get(`roles/permissions/${id}`)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  createRole (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('roles', data)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  deleteRole (id) {
    return new Promise((resolve, reject) => {
      this.$http.delete(`roles/${id}`)
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  updateRole (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.put(`roles/${id}`, data)
        .then(res => res.data)
        .then(resolve)
        .catch(reject)
    })
  }

  assignPermission (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`roles/permissions/assign/${id}`, data)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
    })
  }

  assignPermissions (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`roles/${id}/permissions`, data)
        .then(res => res.data)
        .then(resolve)
        .catch(reject)
    })
  }

  getUserRoles (id) {
    return new Promise((resolve, reject) => {
      this.$http.get(`users/${id}/roles`)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  assignUserRoles (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`users/${id}/roles`, data)
        .then(res => res.data)
        .then(resolve)
        .catch(reject)
    })
  }
}
